import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import {
  CODE_CONFIRMATION_INFO,
  CODE_CONFIRMATION_SECONDS_LEFT,
  RESEND_CODE,
} from '../../../constants';
import { CodeInput } from '@ru-digital-assets/ui-component';

interface IProps {
  requestResend: () => void;
  onInputFill: (value: string) => void;
}

const ConfirmationCodeBody: React.FC<IProps> = ({
  onInputFill,
  requestResend,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(60);
  const [validResend, setValidResend] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (secondsLeft > 0) {
        setSecondsLeft((prevState) => prevState - 1);
      }
      setValidResend(true);
    }, 1000);

    return () => clearInterval(interval);
  });

  const getSecondsString = () => {
    if (!secondsLeft) return CODE_CONFIRMATION_INFO;
    return `${CODE_CONFIRMATION_INFO} ${CODE_CONFIRMATION_SECONDS_LEFT(
      secondsLeft
    )}`;
  };

  return (
    <div className="login-form__body">
      <CodeInput onInputFill={onInputFill} inputLength={4} />
      <div className="login-form__body-bottom">
        <p
          className={classNames('login-form__body-bottom-text', {
            'login-form__body-bottom-text--error': !secondsLeft,
          })}
        >
          {getSecondsString()}
        </p>
        <div
          className="login-form__body-bottom-link"
          onClick={(e) => {
            e && e.stopPropagation();
            if (validResend) requestResend();
          }}
        >
          {RESEND_CODE}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationCodeBody;
